export class Constants {
    static documentSelectionLimit = 6;
}
